#import "../../list/BusinessUnitFields.graphql"
mutation CompanyBusinessUnitCreate($input: CompanyBusinessUnitCreateInput!) {
  companyBusinessUnitCreate(input: $input) {
   companyBusinessUnit {
    ...BusinessUnitFields
    }}
}
